/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Contato from 'assets/images/contato.svg';
import { openSupportChat } from 'services/support_chat';
import { Container } from './styles';

const ContactCard = () => {
  return (
    <Container>
      <div className="row">
        <div className="col-md-12">
          <div
            className="card d-flex mx-auto justify-content-center align-items-center p-5 mt-5"
            style={{ width: '455px' }}
          >
            <img
              className="card-img-top mt-5"
              src={Contato}
              alt="Imagem contato"
              style={{ width: '185px' }}
            />
            <div className="card-body">
              <h5 className="card-title card-title-text">
                Entre em contato para
                <br />
                assinar o ConLicitação
              </h5>
              <p className="card-text-subtitle">
                Para efetuar sua assinatura envie uma mensagem aos nossos consultores ou nos contate
                pelo telefone <strong>0800 11 14133</strong>
              </p>
              <button
                type="button"
                className="btn btn-primary text-center"
                onClick={() => openSupportChat()}
              >
                Solicitar atendimento
              </button>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ContactCard;
